import React from 'react';
export function StoryHero() {
  return <section className="w-full bg-white pt-16 md:pt-20 pb-12 md:pb-14 px-4 sm:px-6 lg:px-8" data-id="element-404" data-mp="2w9xr866mnqvi">
      <div className="max-w-4xl mx-auto" data-id="element-405" data-mp="vuru6fpiizol">
        <div data-id="element-406" data-mp="hvsfo0vps165">
          {/* Photos — floated right so text wraps around them */}
          <div className="hidden md:block float-right ml-12 mb-10 w-[35%] max-w-sm relative" data-id="element-407" data-mp="hxwg28uemi1o">
            <div className="rounded-xl overflow-hidden shadow-2xl relative" data-id="element-408" data-mp="mwpsrz1va50s">
              <img src="https://cdn.magicpatterns.com/uploads/pxPLHfXrbMN7CbWn42GWUT/Headshot_2.jpg" alt="Michael Hirsch - Break a Pencil Consulting" className="w-full aspect-[4/5] object-cover object-center" data-id="element-409" data-mp="845sr7a0kdnk" />
              <div className="absolute inset-0 bg-brand-navy mix-blend-multiply opacity-10" data-id="element-410" data-mp="456v87qm3j65"></div>
            </div>
            <div className="mt-6" data-id="element-411" data-mp="3ldk4x7igu70n">
              <img src="https://cdn.magicpatterns.com/uploads/34kX4YBWUX2jBf573KsCtF/intersection_street_signs_v3.png" alt="Intersection of Team Leadership and Team-Level AI Transformation" className="w-full object-contain" data-id="element-412" data-mp="3lelet8nqwngs" />
            </div>
            <div className="absolute -bottom-8 -right-8 w-40 h-40 bg-brand-orange/10 rounded-full -z-10 blur-3xl" data-id="element-413" data-mp="1ky5obs0k1wya"></div>
            <div className="absolute -top-8 -left-8 w-40 h-40 bg-brand-blue/10 rounded-full -z-10 blur-3xl" data-id="element-414" data-mp="1gw0y739bfige"></div>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-brand-navy leading-tight mb-12" data-id="element-415" data-mp="t7rgacf83euj">
            I've been where your team members are. And where you are.
          </h1>

          {/* Mobile-only photos */}
          <div className="md:hidden mb-12 space-y-8" data-id="element-416" data-mp="121e85rgb7xyg">
            <div className="max-w-sm mx-auto rounded-xl overflow-hidden shadow-2xl relative" data-id="element-417" data-mp="x8bfrmn9quju">
              <img src="https://cdn.magicpatterns.com/uploads/pxPLHfXrbMN7CbWn42GWUT/Headshot_2.jpg" alt="Michael Hirsch - Break a Pencil Consulting" className="w-full aspect-[4/5] object-cover object-center" data-id="element-418" data-mp="9i78n5avgco3" />
              <div className="absolute inset-0 bg-brand-navy mix-blend-multiply opacity-10" data-id="element-419" data-mp="29l8du2nhsaws"></div>
            </div>
            <div className="max-w-sm mx-auto" data-id="element-420" data-mp="2ebf4s95h87i7">
              <img src="https://cdn.magicpatterns.com/uploads/34kX4YBWUX2jBf573KsCtF/intersection_street_signs_v3.png" alt="Intersection of Team Leadership and Team-Level AI Transformation" className="w-full object-contain" data-id="element-421" data-mp="2ecqh4xczmnkx" />
            </div>
          </div>

          <div className="space-y-8 text-xl text-brand-gray leading-relaxed" data-id="element-422" data-mp="1qo782fm466rs">
            <p data-id="element-423" data-mp="1vk5tbuc5b8nz">
              I spent 20+ years leading teams at global companies like Sony,
              Qualcomm, T-Mobile, and HERE Technologies. What I learned is that
              the
              part of the job I actually liked wasn't the politics or the
              internal battles. It was making my team better.
            </p>
            <p data-id="element-424" data-mp="10cvfp4dhufpb">
              Then AI showed up and made that problem ten times harder. Everyone
              experimenting on their own, nobody sharing what works, leaders
              under pressure to show results they don't know how to deliver.
            </p>
          </div>
        </div>
      </div>
    </section>;
}